import React from "react";

const Facebook = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_10_37)">
      <path
        d="M28 14C28 6.26808 21.7319 0 14 0C6.26808 0 0 6.26808 0 14C0 20.5654 4.52032 26.0747 10.6182 27.5878V18.2784H7.73136V14H10.6182V12.1565C10.6182 7.39144 12.7747 5.1828 17.453 5.1828C18.34 5.1828 19.8705 5.35696 20.4966 5.53056V9.40856C20.1662 9.37384 19.5922 9.35648 18.8793 9.35648C16.5838 9.35648 15.6968 10.2262 15.6968 12.4869V14H20.2698L19.4841 18.2784H15.6968V27.8975C22.629 27.0603 28.0006 21.1579 28.0006 14H28Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_10_37">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Facebook.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};
export default Facebook;
